import React, { useState, useEffect } from 'react'
import pfp1 from '../../../assets/images/pfp1.svg'
import bonezIcon from '../../../assets/images/bonez_icon.svg'

import '../../../assets/styles/chat-room.css'
import opCodes from '../../../constants/opCodes';

import { Toast, ToastContainer } from "react-bootstrap";

function Message(props) {
  const { content, count, username, sender_id, self, userAvatars, wagerType, client, session, joinMatch, spectating, time, match_id } = props;
  const [avatarUrl, setAvatarUrl] = useState("");
  const [timeStamp, setTimeStamp] = useState("");
  const [day, setDay] = useState("");
  const [showToast, setShowToast] = useState(false);
  
  const onWatchNowClick = () => {
    if(spectating < 25 && match_id != null){
      joinMatch(match_id); 
    }else {
      setShowToast(true);
    }
  };

  // useEffect for timestamps
  useEffect(() => {
    const getDate = async () => {
      const dateObj = props.time;
      const stamp = new Date(dateObj);
      // console.log("count: ", count);
      setDay(stamp.toDateString().toString().substring(0, 3));
      const time = stamp.toString().substring(15, 21);
      if (time.substring(0, 3) > 12) {
        //checks if the hour is over or under 12 to display PM/AM and adjust time for standard non military time
        const hour = parseInt(time.substring(0, 3)) - 12;
        setTimeStamp(`${hour}:${time.substring(4, 7)} PM`);
        // console.log("timeStamp: ", timeStamp);
      }
      else {
        setTimeStamp(`${time.toString()} AM`);

        // console.log("timeStamp: ", timeStamp);
      }
    }
    getDate()
    // console.log(time.substring(0, 3))
  }, [])



  // useEffect to retrieve players avatar to display in chat 
  useEffect(() => {
    // console.log("userAvatars log in message: ", userAvatars)
    // console.log(sender_id)
    async function getAvatar(sender_id, retryCount = 0) {
      const maxRetries = 2;
      const retryDelay = 1000 * (retryCount + 1);
      
      if (sender_id) {
        if (userAvatars.get(sender_id.toString()) === undefined) {
          try {
            // console.log("sender id:", sender_id)
            const newUser = await client.getUsers(session, sender_id.toString());
            // console.log("new user: ", newUser);
            userAvatars.set(sender_id, newUser.users[0].avatar_url)
            setAvatarUrl(newUser.users[0].avatar_url);
            // console.log(userAvatars);
            // userAvatars.set(sender_id, newUser.users[0].avatar_url);
          } catch (error) {
            console.error("Error getting user avatar:", error);
            
            // Retry on server errors (500) but not on authentication errors
            if (retryCount < maxRetries && 
                (error.message?.includes('500') || error.message?.includes('Internal Server Error'))) {
              console.log(`Retrying getUsers for avatar in ${retryDelay}ms... (attempt ${retryCount + 1}/${maxRetries})`);
              setTimeout(() => getAvatar(sender_id, retryCount + 1), retryDelay);
              return;
            }
            
            // For auth errors, don't retry and check session
            if (error.code === 16 || error.message?.includes('UNAUTHENTICATED')) {
              console.log("Authentication error in avatar retrieval, checking session...");
              // Could call sessionTimeoutCheck here if needed
            }
            
            // Use default avatar on error
            setAvatarUrl(null);
          }
        } else {
          setAvatarUrl((userAvatars.get(sender_id)))
        }
      }
    }
    getAvatar(sender_id);
    // console.log("avatarUrl: ", avatarUrl)
    // setAvatarUrl(userAvatars.get(sender_id.toString()));
    // console.log("avatar get: ", avatarUrl)
  }, [sender_id])

  // Check if the message is a match announcement
  const isMatchAnnouncement = content.includes("Watch Now!");

  // Function to split the content into four parts
  const splitContent = () => {
    const vsIndex = content.indexOf(" vs ");
    const watchNowIndex = content.indexOf("Watch Now!");

    const part1 = content.substring(0, vsIndex);
    const part2 = "vs";
    const part3 = content.substring(vsIndex + 4, watchNowIndex);
    const part4 = "Watch Now!";

    return { part1, part2, part3, part4 };
  };

  // Split content if it is a match announcement
  let parts;
  if (isMatchAnnouncement) {
    parts = splitContent();
  }

  //Get user avatar pfp
  return (
    <div>
       <ToastContainer
          className="p-3"
          position={'bottom-start'} // Set the position here
          style={{ zIndex: 1 }}
        >
          <Toast onClose={() => setShowToast(false)} show={showToast} className="d-inline-block m-1" bg={'success'} style={{ maxWidth: '400px', minHeight: '15px', fontSize: '14px' }} delay={3000} autohide>
            <Toast.Header>
              <strong className="me-auto">Cannot Join the match</strong>
            </Toast.Header>
            <Toast.Body className={`text-white ${'success' === 'Dark' && 'font-weight-bold'}`} style={{ textAlign: 'left' }}>
              Please try again in 15 seconds
            </Toast.Body>
          </Toast>
      </ToastContainer>
      {/* {props.time !== "" &&
        <h1 className="msg-time">{props.time}</h1>
      } */}

      {
        username === "System" &&
        <div>
          <h1 className="leave-join-msg"> {content}</h1>
        </div>
      }
      {(count % 10 === 0 || count === 0) && username !== "System" &&
        <h1 className="leave-join-msg">{day} {timeStamp}</h1>
      }

      {isMatchAnnouncement && 
        <div className="match-announcement">
          {wagerType === "bonez" ? (
            <>
            <img className="chipz-icon message" title="Zoombies Bones" alt="" src={bonezIcon} />
            </>
          ) : (
            <img
              className="chipz-icon message"
              title="Zoombies Chipz"
              src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp"
              alt="Chipz icon"
            /> 
          )}&nbsp;&nbsp;
          <p className="msg-content">
            <span className="text-purple">{parts.part1}</span>
            <span className="text-red"> {parts.part2} </span>
            <span className="text-purple">{parts.part3}</span>
            <span className="text-red clickable-text">
              {parts.part4}
            </span>
          </p>
        </div>
      }

      {username !== "System" && !isMatchAnnouncement &&
        <div className={self ? "self-msg" : "player-msg"}>
          {!self &&
            <>
              <img className="msg-pfp" src={avatarUrl} alt="" />
              <span className="msg-username"> {username}:</span>
            </>
          }
          <p className="msg-content"> {content}</p>
        </div>
      }
    </div>
  )
}

export default Message